<template>
  <Layout>
    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>Visualizar Nota Fiscal</h3>
      </div>
    </div>

    <div class="row">
      <div class="col-md-7 mb-4">
        <div class="card">
          <div class="card-body p-0" style="min-height: 80vh">
            <template v-if="nota.nf_arquivo">
              <iframe
                :src="nota.nf_arquivo"
                width="100%"
                height="600px"
                style="border: none"
              ></iframe>
            </template>
            <template v-else>
              <div class="p-4 text-center">Arquivo não disponível</div>
            </template>
          </div>
        </div>
      </div>

      <div class="col-md-5 mb-4">
        <div class="card">
          <div class="card-body">
            <p><strong>Data de Importação:</strong> {{ formatarDataHora(nota.nf_date_added) }}</p>
            <p><strong>Valor:</strong> {{ formatarMoeda(nota.nf_valor) }}</p>
            <p><strong>Lote:</strong> {{ nota.nf_lote || '—' }}</p>
            <p><strong>Previsão de Pagamento:</strong> {{ formatarData(nota.nf_data_pagamento) }}</p>
            <p>
              <strong>Status:</strong>
              <span :class="['badge', getStatusClass(nota.nf_status)]">
                {{ getStatusLabel(nota.nf_status) }}
              </span>
            </p>
            <p><strong>CNPJ Prestador:</strong> {{ nota.nf_document_prestador || '—' }}</p>
            <p><strong>Nome Prestador:</strong> {{ nota.nf_nome_prestador || '—' }}</p>

            <h5 class="mt-4">Check List</h5>
            <ul class="list-unstyled">
              <li v-for="(label, key) in checkListLabels" :key="key">
                <i
                  :class="nota[key] == 1 ? 'text-success fa fa-check' : 'text-danger fa fa-times'"
                ></i>
                {{ label }}
              </li>
            </ul>

            <h5 class="mt-4">Observações</h5>
            <div v-html="nota.nf_observacoes"></div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/router/layouts/main';
import { api } from '@/state/services';

export default {
  components: { Layout },
  data() {
    return {
      nota: {},
      checkListLabels: {
        nf_check_competencia: 'Competência',
        nf_check_cnpj: 'CNPJ',
        nf_check_tomador_servico: 'Tomador de Serviço',
        nf_check_cod_tributacao: 'Código de Tributação',
        nf_check_informacoes_bancarias: 'Informações Bancárias',
        nf_check_valor: 'Valor'
      }
    };
  },
  mounted() {
    const idNota = this.$route.params.idNota;
    api.get(`notasfiscais/buscarbrasil/${idNota}`).then(res => {
      if (res.data.status === 'success') {
        this.nota = res.data.nota;
      }
    });
  },
  methods: {
    formatarData(data) {
      if (!data) return '—';
      return new Date(data + 'T00:00:00').toLocaleDateString('pt-BR', {
        timeZone: 'America/Sao_Paulo'
      });
    },
    formatarDataHora(data) {
      if (!data) return '—';
      return new Date(data).toLocaleString('pt-BR', {
        timeZone: 'America/Sao_Paulo'
      });
    },
    formatarMoeda(valor) {
      if (!valor || isNaN(valor)) return 'R$ 0,00';
      return parseFloat(valor).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      });
    },
    getStatusClass(status) {
      return {
        pending: 'badge-warning',
        approved: 'badge-success',
        reproved: 'badge-danger',
        returned: 'badge-purple'
      }[status] || 'badge-secondary';
    },
    getStatusLabel(status) {
      return {
        pending: 'Pendente',
        approved: 'Aprovado',
        reproved: 'Reprovado',
        returned: 'Devolvida'
      }[status] || 'Desconhecido';
    }
  }
};
</script>

<style scoped>
.badge-purple {
  background-color: var(--st-status-returned-text);
  color: var(--st-text-inverse);
}
</style>

